import axios from '../axiosConfig'
import { tokenConfig } from './auth'

import {
  GET_PRECIO,
  GET_PRECIO_SUCCESS,
  GET_PRECIO_FAIL,
  GET_PRECIOS,
  GET_PRECIOS_SUCCESS,
  GET_PRECIOS_FAIL,
} from './types'

let body

export const getPrecio =
  (codigo_articulo, cantidad_pedida = 1, domicilio_envio = '', presentacion = 'UN') =>
  (dispatch, getState) => {
    dispatch({
      type: GET_PRECIO,
      codigo_articulo: codigo_articulo,
      presentacion: 'UN',
    })

    let articulos_cantidades = [
      {
        codigo_articulo: codigo_articulo,
        cantidad: cantidad_pedida,
        presentacion: 'UN',
      },
    ]

    body = JSON.stringify({
      articulos_cantidades: articulos_cantidades,
      domicilio_envio: domicilio_envio,
    })

    axios
      .post(`/articulos/preciosValoracion`, body, tokenConfig(getState))
      .then(res => {
        dispatch({
          type: GET_PRECIO_SUCCESS,
          codigo_articulo: codigo_articulo,
          presentacion: 'UN',
          payload: res.data.v1_b2b_products_pricesamounts_out_list[0],
        })
      })
      .catch(err => {
        // console.log("Precio:", err.response.data);
        dispatch({
          type: GET_PRECIO_FAIL,
          codigo_articulo: codigo_articulo,
          presentacion: 'UN',
        })
      })
  }

export const getPrecios =
  (articulos_cantidades = [], origen = '', domicilio_envio = '', maximo_agrupados = 36) =>
  (dispatch, getState) => {
    //Comprobamos si supera el maximo

    if (articulos_cantidades.length > Number(maximo_agrupados)) {
      let z = 0 //Indice del array de arrays
      let array_aux = [] //Declaramos un array auxiliar
      array_aux[z] = [] //Lo iniciamos como array de arrays

      for (let x = 0; x < articulos_cantidades.length; x++) {
        //Hacemos push del valor actual
        array_aux[z].push({
          codigo_articulo: articulos_cantidades[x].codigo_articulo,
          cantidad: articulos_cantidades[x].cantidad,
          presentacion: 'UN',
        })

        //Si x es divisor entero del maximo (sin ser 0 o 1)
        if (
          x !== 0 &&
          x !== 1 &&
          (x + 1) % Number(maximo_agrupados) === 0 &&
          x + 1 !== articulos_cantidades.length
        ) {
          z++ //Aumentamos el indice
          array_aux[z] = [] //Iniciamos el siguiente valor
        }
      }
      z = 0
      //Lanzamos peticion de precios variable del array de arrays
      array_aux.forEach(array_articulos => {
        body = JSON.stringify({
          articulos_cantidades: array_articulos,
          domicilio_envio,
        })
        z++
        dispatch({
          type: GET_PRECIOS,
          articulos_cantidades: array_articulos,
        })

        axios
          .post(`/articulos/preciosValoracion?origen=${origen}`, body, tokenConfig(getState))
          .then(res => {
            dispatch({
              type: GET_PRECIOS_SUCCESS,
              articulos_cantidades: array_articulos,
              payload: res.data.v1_b2b_products_pricesamounts_out_list,
            })
          })
          .catch(err => {
            console.error(err)
            console.log('La peticion de precios ha fallado.')
            dispatch({
              type: GET_PRECIOS_FAIL,
              articulos_cantidades: array_articulos,
            })
          })
      })
    } else {
      //Si no supera el maximo se lanza una unica peticion
      body = JSON.stringify({
        articulos_cantidades,
        domicilio_envio,
      })
      dispatch({
        type: GET_PRECIOS,
        articulos_cantidades: articulos_cantidades,
      })
      axios
        .post(`/articulos/preciosValoracion?origen=${origen}`, body, tokenConfig(getState))
        .then(res => {
          dispatch({
            type: GET_PRECIOS_SUCCESS,
            articulos_cantidades: articulos_cantidades,
            payload: res.data.v1_b2b_products_pricesamounts_out_list,
          })
        })
        .catch(err => {
          console.log('La peticion de precios ha fallado.')
          dispatch({
            type: GET_PRECIOS_FAIL,
            articulos_cantidades: articulos_cantidades,
          })
        })
    }
  }
